module.exports = __webpack_public_path__ + "media/img/uploads/event-thumb-02-e7e5411382108da751e00ceacc5977b1.jpg";